import React from 'react';
import { Button, Dialog, IconButton, makeStyles, Typography, withStyles } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import CloseIcon from '@material-ui/icons/Close';
// import ButtonComp from '../../../components/button';
// import { Redirect } from 'react-router-dom';

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
        textAlign: 'center',
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    //console.log(props );
    //console.log(onClose);
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            <Typography variant="subtitle1">click generate to generate invoice</Typography>
            {onClose ? (
                // <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                //     <CloseIcon />
                // </IconButton>
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(1),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
    dialogPaper: {
        minHeight: '100vh',
        maxHeight: '100vh',
    },
    btn: {
        width: '40%',
        color: 'white',
        fontWeight: 400,
        letterSpacing: '3px',
        background: 'hsl(33deg 94% 54%)',
        position: 'relative',
        height: '40px',
        border: '0',
        margin: '16px auto',
        fontSize: '1.25vw',
        fontFamily: 'Playfair Display, serif',
        cursor: 'pointer',
        '&:hover': {
            background: 'hsl(33deg 94% 54%)',
        },
    },
    center: {
        textAlign: 'center',
    },
    textArea: {
        display: 'inline-flex',
        resize: 'none',
        marginLeft: '60px',
    },
    textarea1: {
        marginRight: '60px',
        resize: 'none',
    },
    textarea2: {
        marginLeft: '50px',
        resize: 'none',
    },
}));

function RecieptPopup(props) {
    const { openP, handleClose, row, onGenerate, post } = props;
    // const [fullWidth, setFullWidth] = React.useState(true);
    // const [value , setValue] = React.useState('')

    const classes = useStyles();

    //console.log(handleClose, openP, row);
    //console.log("row Details to the  PopUp ****", row);

    // handle Change on Text Area

    const handleChange = () => {
        //console.log("value Changed");
    };

    // Generation of Tax Invoice

    const submitData = (data) => {
        //console.log(data ,"data From Generation")
        onGenerate(data);
        handleClose();
    };

    //console.log("yes Popup");

    return (
        <div>
            <Dialog
                onClose={handleClose}
                fullWidth
                maxWidth="md"
                className={classes.dialogPaper}
                aria-labelledby="customized-dialog-title"
                open={openP}
            >
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    UPDATE DETAILS AND GENERATE INVOICE
                </DialogTitle>
                <DialogContent>
                    <Typography className={classes.center} variant="h6" gutterBottom>
                        ABC Consultant
                    </Typography>
                    <Typography className={classes.center} variant="h4" gutterBottom>
                        Popup from {post} Table
                    </Typography>
                    <div className={classes.textArea}>
                        <textarea
                            aria-label="minimum height"
                            className={classes.textarea1}
                            rows="4"
                            cols="40"
                            defaultValue="120000"
                            value={row.gstin}
                            onChange={handleChange}
                        />
                        <textarea
                            aria-label="minimum height"
                            rows="4"
                            cols="40"
                            className={classes.textarea2}
                            defaultValue="Address List"
                            value={row.address}
                            onChange={handleChange}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button type="button" color="primary" onClick={() => submitData(row)} className={classes.btn}>
                        Generate
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default RecieptPopup;
